import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	linkIssue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkConfluencePage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addWebLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachFile: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkIssueIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	linkIssue: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.button-item.link-issue',
		defaultMessage: 'Link issue',
		description: 'Linking an issue to the selected issue',
	},
	linkConfluencePage: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.button-item.link-confluence-page',
		defaultMessage: 'Link Confluence page',
		description: 'Linking a confluence page to the selected issue',
	},
	addWebLink: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.button-item.add-web-link',
		defaultMessage: 'Add web link',
		description: 'Adding a web link to the selected issue',
	},
	attachFile: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.button-item.attach-file',
		defaultMessage: 'Attach file',
		description: 'Attach file to Jira issue',
	},
	linkIssueIssueTerminologyRefreshM4: {
		id: 'issue-navigator-issue-operations.dropdown-menu-group.button-item.link-issue-issue-terminology-refresh-m4',
		defaultMessage: 'Link work item',
		description: 'Linking an issue to the selected issue',
	},
});
export default messages;
